import { authGet, authPost, authPut, authDelete } from '../../utils/authFetch';
import { userServerAddress } from '../../common/MetaSetting';
import { fetchHttpResponseHandler, fetchHttpExceptionHandler } from '../../util/UtilFunction';

function extractArrayData(response: any, apiName: string): any[] {
  console.log(`🔍 ${apiName} - 原始响应结构:`, JSON.stringify(response, null, 2));
  
  if (!response) {
    console.warn(`${apiName}: response is null/undefined`);
    return [];
  }

  if (Array.isArray(response)) {
    console.log(`✅ ${apiName}: response 本身是数组, 长度: ${response.length}`);
    return response;
  }
  
  if (response.data && Array.isArray(response.data)) {
    console.log(`✅ ${apiName}: 从 response.data 提取数组, 长度: ${response.data.length}`);
    return response.data;
  }
  
  const possibleKeys = ['data', 'content', 'list', 'records', 'items', 'friends', 'groups', 'result'];
  for (const key of possibleKeys) {
    if (Array.isArray(response[key])) {
      console.log(`✅ ${apiName}: 从 response.${key} 提取数组, 长度: ${response[key].length}`);
      return response[key];
    }
  }

  console.warn(`${apiName}: ⚠️ 无法从响应中提取数组!`);
  console.warn(`  - response 类型:`, typeof response);
  console.warn(`  - response keys:`, Object.keys(response));
  return [];
}

export interface AddFriendRequest {
  friendId: number;
  group?: string;
}

export interface UpdateFriendRequest {
  remark?: string;
  group?: string;
}

export interface FriendshipResponse {
  id: string;
  userId: number;
  friendId: number;
  status: number;
  remark: string;
  group: string;
  createdAt: string;
  updatedAt: string;
}

export function addFriend(request: AddFriendRequest) {
  return authPost(`${userServerAddress}/friendship/add`, {
    body: JSON.stringify({
      friendId: request.friendId,
      group: '默认分组'
    })
  })
    .then((response: any) => fetchHttpResponseHandler(response))
    .catch(fetchHttpExceptionHandler);
}

export function acceptFriend(friendshipId: string) {
  return authPost(`${userServerAddress}/friendship/accept/${friendshipId}`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .catch(fetchHttpExceptionHandler);
}

export function rejectFriend(friendshipId: string) {
  return authPost(`${userServerAddress}/friendship/reject/${friendshipId}`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .catch(fetchHttpExceptionHandler);
}

export function deleteFriend(friendshipId: string) {
  return authDelete(`${userServerAddress}/friendship/delete/${friendshipId}`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .catch(fetchHttpExceptionHandler);
}

export function updateFriend(friendshipId: string, request: UpdateFriendRequest) {
  return authPut(`${userServerAddress}/friendship/update/${friendshipId}`, {
    body: JSON.stringify(request)
  })
    .then((response: any) => fetchHttpResponseHandler(response))
    .catch(fetchHttpExceptionHandler);
}

export function getFriends() {
  return authGet(`${userServerAddress}/friendship/list`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .then((response) => {
      const data = extractArrayData(response.content, 'getFriends');
      console.log('getFriends - extracted data length:', data.length);
      return data;
    })
    .catch((error) => {
      console.error('getFriends error:', error);
      return [];
    });
}

export function getPendingRequests() {
  return authGet(`${userServerAddress}/friendship/pending`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .then((response) => {
      const data = extractArrayData(response.content, 'getPendingRequests');
      console.log('getPendingRequests - extracted data length:', data.length);
      return data;
    })
    .catch((error) => {
      console.error('getPendingRequests error:', error);
      return [];
    });
}

export function getSentRequests() {
  return authGet(`${userServerAddress}/friendship/sent`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .then((response) => {
      const data = extractArrayData(response.content, 'getSentRequests');
      console.log('getSentRequests - extracted data length:', data.length);
      return data;
    })
    .catch((error) => {
      console.error('getSentRequests error:', error);
      return [];
    });
}

export function getFriendsByGroup(group: string) {
  return authGet(`${userServerAddress}/friendship/group/${group}`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .then((response) => {
      const data = extractArrayData(response.content, 'getFriendsByGroup');
      console.log('getFriendsByGroup - extracted data length:', data.length);
      return data;
    })
    .catch((error) => {
      console.error('getFriendsByGroup error:', error);
      return [];
    });
}

export function acceptFriendRequest(requestId: string) {
  return authPost(`${userServerAddress}/friendship/accept/${requestId}`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .catch(fetchHttpExceptionHandler);
}

export function rejectFriendRequest(requestId: string) {
  return authPost(`${userServerAddress}/friendship/reject/${requestId}`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .catch(fetchHttpExceptionHandler);
}

export function ignoreFriendRequest(requestId: string) {
  return authPost(`${userServerAddress}/friendship/ignore/${requestId}`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .catch(fetchHttpExceptionHandler);
}
